// On-chain metrics — RE₿EL LLM pipeline translation (Sprint B).
// id keys preserved from ES.

export const METRICAS_ONCHAIN = [
  {
    id: "fear-greed",
    nombre: "恐惧与贪婪指数",
    dificultad: "basica",
    descripcion: "最常用的加密货币市场整体情绪衡量指标。综合波动性、动量、交易量、社交媒体、主导地位和谷歌搜索,形成0(极度恐惧)到100(极度贪婪)的量表。沃伦·巴菲特:「在别人恐惧时贪婪,在别人贪婪时恐惧」。",
    apiUrl: "https://api.alternative.me/fng/",
    interpretacion: [
      {
        rango: "0-25",
        senal: "极度恐惧",
        color: "green",
        descripcion: "市场恐慌。历史上是长期持有者的买入信号。机构正在悄悄积累。"
      },
      {
        rango: "26-45",
        senal: "恐惧",
        color: "lime",
        descripcion: "负面情绪。散户正在离场。分析看涨设置的机会。"
      },
      {
        rango: "46-55",
        senal: "中性",
        color: "yellow",
        descripcion: "市场处于平衡状态。没有明确偏向。等待方向确认。"
      },
      {
        rango: "56-75",
        senal: "贪婪",
        color: "orange",
        descripcion: "适度狂热。市场上涨但需谨慎。减少仓位或开始部分获利。"
      },
      {
        rango: "76-100",
        senal: "极度贪婪",
        color: "red",
        descripcion: "最大狂热。历史上是市场顶部信号。机构正在派发。最大警惕。"
      }
    ]
  },
  {
    id: "nupl",
    nombre: "NUPL — 未实现净盈亏",
    dificultad: "intermedia",
    descripcion: "衡量比特币持有者整体是处于未实现盈利还是亏损状态。计算公式为(市值 − 已实现市值)/ 市值。是识别周期顶部和底部最可靠的指标之一。",
    interpretacion: [
      {
        rango: "> 0.75",
        senal: "狂热",
        color: "red",
        descripcion: "绝大多数持有者拥有巨额未实现收益。机构派发区域。历史上预示50-80%的回调。"
      },
      {
        rango: "0.5-0.75",
        senal: "信念",
        color: "orange",
        descripcion: "市场正在成熟牛市周期。仍有上涨空间但风险更高。"
      },
      {
        rango: "0.25-0.5",
        senal: "乐观",
        color: "lime",
        descripcion: "健康的看涨阶段。回调时的良好入场点。"
      },
      {
        rango: "0-0.25",
        senal: "希望",
        color: "green",
        descripcion: "过渡期。市场正从底部恢复。积累机会。"
      },
      {
        rango: "< 0",
        senal: "投降",
        color: "green",
        descripcion: "大多数人处于亏损状态。最大恐慌。历史上的周期底部区域。长期最佳买入机会。"
      }
    ]
  },
  {
    id: "exchange-flow",
    nombre: "交易所流入/流出",
    dificultad: "basica",
    descripcion: "追踪比特币进出中心化交易所的流动。当持有者将BTC发送到交易所时,暗示卖出意图(看跌)。当他们从交易所提取BTC到私人钱包时,暗示持有意图(看涨)。净流入交易所通常预示下跌。",
    interpretacion: [
      {
        rango: "Inflow alto",
        senal: "看跌",
        color: "red",
        descripcion: "大量BTC流入交易所。准备卖出。短期内增加卖压。"
      },
      {
        rango: "Outflow alto",
        senal: "看涨",
        color: "green",
        descripcion: "大量BTC流出交易所。持有者存入自己的钱包。减少可供出售的供应。"
      },
      {
        rango: "Flujo neutro",
        senal: "无信号",
        color: "yellow",
        descripcion: "等待价格确认。本身不是触发因素。"
      }
    ]
  },
  {
    id: "mvrv",
    nombre: "MVRV 比率",
    dificultad: "intermedia",
    descripcion: "市值与已实现价值比率。将当前市场价格与持有者购买BTC的平均价格(已实现价格)进行比较。高MVRV意味着持有者拥有大量未实现收益并可能卖出。低MVRV(接近1)历史上标志着周期底部。",
    interpretacion: [
      {
        rango: "MVRV > 3.5",
        senal: "极度高估",
        color: "red",
        descripcion: "持有者平均拥有3.5倍投资收益。历史上的顶部区域。BTC历史上仅出现3次。"
      },
      {
        rango: "MVRV 2-3.5",
        senal: "警告",
        color: "orange",
        descripcion: "市场昂贵但可能继续。逐步减少敞口。"
      },
      {
        rango: "MVRV 1-2",
        senal: "健康",
        color: "lime",
        descripcion: "市场估值合理。"
      },
      {
        rango: "MVRV < 1",
        senal: "投降",
        color: "green",
        descripcion: "BTC交易价格低于所有持有者的平均购买价格。历史上长期最佳买入机会区域。"
      }
    ]
  },
  {
    id: "dominancia-btc",
    nombre: "比特币主导地位 (BTC.D)",
    dificultad: "basica",
    descripcion: "比特币占加密货币总市值的百分比。判断何时在BTC和山寨币之间轮动的关键指标。典型周期：BTC先上涨（主导地位上升）→ ETH和大市值币跟随 → 小市值山寨币爆发（主导地位下降）→ 全面崩盘 → BTC重新领涨。",
    apiUrl: "https://api.coingecko.com/api/v3/global",
    interpretacion: [
      {
        rango: "D > 60% 上升中",
        senal: "BTC season",
        color: "orange",
        descripcion: "资金流向BTC。市场保守。应持有更多BTC而非山寨币。"
      },
      {
        rango: "D 50-60%",
        senal: "过渡期",
        color: "yellow",
        descripcion: "BTC巩固领导地位。开始关注ETH和大市值币。"
      },
      {
        rango: "D 40-50% 下降中",
        senal: "山寨币季节",
        color: "lime",
        descripcion: "轮动至优质山寨币。ETH、SOL、BNB领涨。"
      },
      {
        rango: "D < 40%",
        senal: "山寨币狂热",
        color: "green",
        descripcion: "山寨币季节全面爆发。小市值币成倍增长。风险最高——下一步通常是山寨币崩盘。"
      }
    ]
  },
  {
    id: "puell-multiple",
    nombre: "Puell Multiple",
    dificultad: "avanzada",
    descripcion: "通过比较每日挖出的BTC价值与年度平均值来衡量比特币矿工的盈利能力。矿工是BTC的结构性卖方，需要出售BTC来支付运营成本。高Puell值意味着矿工盈利丰厚，可能卖出更多。历史上极低的Puell值标志着底部。",
    interpretacion: [
      {
        rango: "Puell > 4",
        senal: "周期顶部",
        color: "red",
        descripcion: "矿工盈利极高。矿工抛压大。历史上的顶部区域（仅在极端牛市中出现）。"
      },
      {
        rango: "Puell 1-4",
        senal: "市场活跃",
        color: "orange",
        descripcion: "产出与需求平衡。"
      },
      {
        rango: "Puell 0.3-0.5",
        senal: "矿工投降",
        color: "green",
        descripcion: "矿工陷入困境。最弱的矿工投降，价格通常触底。历史上的周期性买入机会。"
      }
    ]
  }
];

export const RECURSOS_EXTERNOS = [
  {
    nombre: "Glassnode",
    url: "https://glassnode.com",
    desc: "链上指标的专业标准。免费计划功能有限，高级版面向机构用户。"
  },
  {
    nombre: "CryptoQuant",
    url: "https://cryptoquant.com",
    desc: "专注于交易所资金流动和矿工指标。提供优质的免费计划。"
  },
  {
    nombre: "LookIntoBitcoin",
    url: "https://www.lookintobitcoin.com",
    desc: "BTC历史周期指标。100%免费且极具教学价值。"
  }
];
